import { defaultImageUrl } from './base';

export interface IManufacturer {
  name: string;
  logo: string;
  partsCount: number;
}

export const manufacturersData: IManufacturer[] = [
  {
    name: 'BENZ',
    logo: defaultImageUrl,
    partsCount: 935803,
  },
  {
    name: 'BMW',
    logo: defaultImageUrl,
    partsCount: 41165,
  },
  {
    name: 'NISSAN',
    logo: 'https://g.autoimg.cn/@img/car3/cardfs/series/g28/M03/0B/A6/100x100_autohomecar__ChxkmmS_YSyABzW1AACF5KOWKG4298.png',
    partsCount: 99193,
  },
  {
    name: 'LANDROVER',
    logo: 'https://g.autoimg.cn/@img/car3/cardfs/series/g26/M02/FD/8D/100x100_autohomecar__ChxkjmS_YvSACTTCAAM26gVJaHU916.png',
    partsCount: 203475,
  },
  {
    name: 'JAGUAR',
    logo: 'https://g.autoimg.cn/@img/car3/cardfs/series/g25/M06/73/88/100x100_autohomecar__ChxkqWTCDnqAO-krAABuYvbDp38898.png',
    partsCount: 141021,
  },
  {
    name: 'GEELY',
    logo: 'https://g.autoimg.cn/@img/car3/cardfs/series/g28/M01/14/02/100x100_autohomecar__ChxkmmTCDuGAHSjSAABF02FAqfo394.png',
    partsCount: 137107,
  },
  {
    name: 'CHERY',
    logo: 'https://g.autoimg.cn/@img/car3/cardfs/series/g31/M0B/33/8C/100x100_autohomecar__ChxoHme-eTyAdlOJAABg_pr6Id8855.png',
    partsCount: 100670,
  },
  {
    name: 'GWM',
    logo: 'https://g.autoimg.cn/@img/car3/cardfs/series/g28/M01/35/0D/100x100_autohomecar__ChxkmmTLPJWARUbsAAEpwVxX6I8080.png',
    partsCount: 60858,
  },
  {
    name: 'BOSCH',
    logo: 'https://fe-static.cassmall.com/assets/images/20260119091729/Bosch-Logo-PNG12 (1).png',
    partsCount: 2269,
  },
  {
    name: 'ZF',
    logo: 'https://fe-static.cassmall.com/assets/images/20260119091747/ZF_logo_PNG_(8).png',
    partsCount: 1698,
  },
  {
    name: 'DENSO',
    logo: 'https://fe-static.cassmall.com/assets/images/20260119091740/DENSO_logo_PNG_(3).png',
    partsCount: 1030,
  },
  {
    name: 'CORTECO',
    logo: 'https://fe-static.cassmall.com/assets/images/20260107180245/corteco-logo.png',
    partsCount: 924,
  },
];
